/**
 * The site's domain name.
 */
export const DOMAIN_NAME = 'fiverr.com';
